import React from "react";
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import PDAHeader from "src/components/common/Header";
import PDA1131_R01Store from "./PDA1131_R01Store";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import { usePDA1131_R01Content } from "./PDA1131_R01Content";

// 목록 화면
import PDA1131_R01Search from "./PDA1131_R01Search";
import PDA1131_R01Table from "./PDA1131_R01Table";

// 상세 화면
import PDA1131_R01DetailInfo from "./PDA1131_R01DetailInfo";
import PDA1131_R01DetailTable from "./PDA1131_R01DetailTable";

/** Container props — PDA 메뉴에서 전달 */
interface PDA1131_R01ContainerProps {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

/** PDA1131_R01 루트 — 목록/상세 화면 전환, 헤더·로딩 처리 */
const PDA1131_R01Container = ({
  menuNm,
  menuCd,
  onBack,
}: PDA1131_R01ContainerProps) => {
  // 전역 로딩·화면 전환·목록 데이터
  const {
    loading,
    reset,
    showList,
    shippingOrderList,
  } = PDA1131_R01Store();

  /** 메뉴 이동 시 store 초기화 */
  const { handleMenuClick } = usePDAContainer(reset);
  /** 목록 조회·상세 진입·뒤로가기 */
  const {
    handleSearch,
    handleSelectOrder,
    handleBackToList,
  } = usePDA1131_R01Content();

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      <PDAHeader
        menuNm={menuNm}
        menuCd={menuCd}
        onBack={showList ? onBack : handleBackToList}
        onMenuClick={handleMenuClick}
      />

      <div className="flex-1 overflow-hidden">
        {showList ? (
          // ========== 목록 화면 ==========
          <div className="h-full flex flex-col">
            <PDA1131_R01Search onSearch={handleSearch} />
            <div className="flex-1 overflow-hidden">
              <PDA1131_R01Table
                shippingOrderList={shippingOrderList}
                onSelectOrder={handleSelectOrder}
              />
            </div>
          </div>
        ) : (
          // ========== 상세 화면 ==========
          <div className="h-full flex flex-col">
            <PDA1131_R01DetailInfo />
            <div className="flex-1 overflow-hidden">
              <PDA1131_R01DetailTable />
            </div>
          </div>
        )}
      </div>

      {loading && <SpinnerOverlay text="처리 중..." />}
    </div>
  );
};

export default PDA1131_R01Container;
